import _styled2styled_components from 'styled-components';
            const _styled2 = typeof _styled2styled_components.default === 'undefined' ? _styled2styled_components : _styled2styled_components.default;;
import _styledstyled_components from 'styled-components';
            const _styled = typeof _styledstyled_components.default === 'undefined' ? _styledstyled_components : _styledstyled_components.default;;
import React from 'react';
import { download } from '../utils/download';
import { ArrowLeftIcon, ArrowRightIcon, DownloadIcon, OneToOneIcon, RotateLeftIcon, RotateRightIcon, ZoomInIcon, ZoomOutIcon } from './Icons';

// 工具栏box样式
const StyledBox = _styled.div.withConfig({
  componentId: "sc-ooqigt-0"
})({
  "pointerEvents": "auto",
  "display": "flex",
  "alignItems": "center",
  "borderRadius": "0.375rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(31 41 55 / var(--tw-bg-opacity))",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem"
});
// 工具栏按钮样式
export const DragStyledItem = _styled.button.withConfig({
  componentId: "sc-ooqigt-1"
})({
  "marginTop": "0.5rem",
  "marginBottom": "0.5rem",
  "marginLeft": "0.375rem",
  "marginRight": "0.375rem",
  "cursor": "pointer",
  "borderRadius": "0.25rem",
  "padding": "0.25rem",
  "fontSize": "20px",
  ":hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(75 85 99 / var(--tw-bg-opacity))"
  },
  ":disabled": {
    "cursor": "not-allowed",
    "--tw-text-opacity": "1",
    "color": "rgb(75 85 99 / var(--tw-text-opacity))"
  },
  ":disabled:hover": {
    "backgroundColor": "transparent"
  }
});
// 工具栏文字样式
export const DragStyledLabel = _styled(DragStyledItem).withConfig({
  componentId: "sc-ooqigt-2"
})({
  "marginTop": "0px",
  "marginBottom": "0px",
  "marginLeft": "0px",
  "marginRight": "0px",
  "cursor": "default",
  "fontSize": "16px",
  ":hover": {
    "backgroundColor": "transparent"
  }
});
// 工具栏分割线样式
export const DragStyledSplit = _styled.div.withConfig({
  componentId: "sc-ooqigt-3"
})({
  "marginLeft": "0.375rem",
  "marginRight": "0.375rem",
  "display": "flex",
  "height": "1rem",
  "alignItems": "center",
  "justifyContent": "center",
  "borderLeftWidth": "1px",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(75 85 99 / var(--tw-border-opacity))"
});
const getScaleStep = (scale, isAdd = true) => {
  if (scale < 0.5 || !isAdd && scale === 0.5) return 0.05;
  if (scale < 1.5 || !isAdd && scale === 1.5) return 0.1;
  if (scale < 3 || !isAdd && scale === 3) return 0.25;
  return 0.5;
};
export const DragArrowLeft = ({
  index,
  onIndexChange,
  images,
  className,
  children
}) => {
  const count = images.length;
  // 当前在第一张
  const isFirst = index === 0;
  const prev = () => {
    onIndexChange(isFirst ? count - 1 : index - 1);
  };
  return <DragStyledItem disabled={isFirst} onClick={prev} className={className}>
      {children ?? <ArrowLeftIcon />}
    </DragStyledItem>;
};
export const DragCountText = ({
  index,
  images,
  className,
  children
}) => {
  const count = images.length;
  return <DragStyledLabel className={className}>{children ?? `${index + 1}/${count}`}</DragStyledLabel>;
};
export const DragArrowRight = ({
  index,
  onIndexChange,
  images,
  className,
  children
}) => {
  const count = images.length;
  // 当前在最后一张
  const isLast = index === count - 1;
  const next = () => {
    onIndexChange(isLast ? 0 : index + 1);
  };
  return <DragStyledItem disabled={isLast} onClick={next} className={className}>
      {children ?? <ArrowRightIcon />}
    </DragStyledItem>;
};
export const DragSplit = ({
  className
}) => {
  return <DragStyledSplit className={className} />;
};
export const DragZoomOut = ({
  scale,
  onScale,
  loading,
  className,
  children
}) => {
  const handleZoomOut = () => {
    onScale(scale - getScaleStep(scale, false));
  };
  return <DragStyledItem disabled={loading} onClick={handleZoomOut} className={className}>
      {children ?? <ZoomOutIcon />}
    </DragStyledItem>;
};
export const DragScaleCount = ({
  scale,
  className,
  children
}) => {
  return <DragStyledLabel className={className}>
      {children ?? `${Math.round(scale * 100)}%`}
    </DragStyledLabel>;
};
export const DragZoomIn = ({
  scale,
  onScale,
  loading,
  className,
  children
}) => {
  const handleZoomIn = () => {
    onScale(scale + getScaleStep(scale));
  };
  return <DragStyledItem disabled={loading} onClick={handleZoomIn} className={className}>
      {children ?? <ZoomInIcon />}
    </DragStyledItem>;
};
export const DragOneToOne = ({
  onScale,
  loading,
  className,
  children
}) => {
  const handleOneToOne = () => {
    onScale(1);
  };
  return <DragStyledItem disabled={loading} onClick={handleOneToOne} className={className}>
      {children ?? <OneToOneIcon />}
    </DragStyledItem>;
};
export const DragDownload = ({
  images,
  index,
  loading,
  className,
  children
}) => {
  const handleDownload = () => {
    const {
      src
    } = images[index];
    if (!src) return;
    download(src);
  };
  return <DragStyledItem disabled={loading} onClick={handleDownload} className={className}>
      {children ?? <DownloadIcon />}
    </DragStyledItem>;
};
export const DragRotateLeft = ({
  rotate,
  onRotate,
  loading,
  className,
  children
}) => {
  const handleRotateLeft = () => {
    onRotate(rotate - 90);
  };
  return <DragStyledItem disabled={loading} onClick={handleRotateLeft} className={className}>
      {children ?? <RotateLeftIcon />}
    </DragStyledItem>;
};
export const DragRotateRight = ({
  rotate,
  onRotate,
  loading,
  className,
  children
}) => {
  const handleRotateRight = () => {
    onRotate(rotate + 90);
  };
  return <DragStyledItem disabled={loading} onClick={handleRotateRight} className={className}>
      {children ?? <RotateRightIcon />}
    </DragStyledItem>;
};
export const DragToolbarItemDefaultComponent = {
  arrowLeft: DragArrowLeft,
  countText: DragCountText,
  arrowRight: DragArrowRight,
  split: DragSplit,
  zoomOut: DragZoomOut,
  scaleCount: DragScaleCount,
  zoomIn: DragZoomIn,
  oneToOne: DragOneToOne,
  download: DragDownload,
  rotateLeft: DragRotateLeft,
  rotateRight: DragRotateRight
};
export const DragToolbar = ({
  items = ['arrowLeft', 'countText', 'arrowRight', 'split', 'zoomOut', 'scaleCount', 'zoomIn', 'oneToOne', 'split', 'download', 'split', 'rotateLeft', 'rotateRight'],
  children,
  className,
  ...props
}) => {
  return <_StyledDiv className={className} $_css={[{
    "pointerEvents": "none",
    "position": "absolute",
    "bottom": "0px",
    "left": "0px",
    "right": "0px",
    "zIndex": "30",
    "marginTop": "1.25rem",
    "marginBottom": "2rem",
    "display": "flex",
    "cursor": "pointer",
    "userSelect": "none",
    "alignItems": "center",
    "justifyContent": "center",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    "opacity": "1",
    "transitionProperty": "opacity",
    "transitionTimingFunction": "linear",
    "transitionDuration": "150ms",
    "transitionDelay": "200ms",
    ":hover": {
      "opacity": "1"
    }
  }, !props.overlayVisible && {
    "opacity": "0"
  }]}>
      <StyledBox>
        {items.map((item, index) => {
        if (typeof item === 'string') {
          const Component = DragToolbarItemDefaultComponent[item];
          if (!Component) return null;
          let key = item;
          if (key === 'split') {
            key = `split-${index}`;
          }
          return <Component key={key} {...props} />;
        }
        const Component = item.component;
        return <Component key={item.key} {...props} />;
      })}
      </StyledBox>
      {children}
    </_StyledDiv>;
};
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-ooqigt-4"
})(["", ""], p => p.$_css);